import { render, staticRenderFns } from "./superAdminLayout.vue?vue&type=template&id=0631dbf5&"
import script from "./superAdminLayout.vue?vue&type=script&lang=js&"
export * from "./superAdminLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports